import type { TourStepData } from './types';

export const growthDashboardTourSteps: TourStepData[] = [
  {
    target: '[data-tour="growth-dashboard-header"]',
    title: 'Growth Dashboard',
    content:
      'Le Growth Dashboard (Tableau de bord croissance) offre une vue d\'ensemble de l\'activite de votre plateforme : utilisateurs, organisations, feedbacks et projets.',
    placement: 'bottom',
  },
  {
    target: '.grid.grid-cols-1.sm\\:grid-cols-2.lg\\:grid-cols-4',
    title: 'KPIs principaux',
    content:
      'Les KPIs (Indicateurs cles de performance) affichent les metriques essentielles en temps reel. Suivez la croissance utilisateur, le volume de feedbacks et le nombre de projets.',
    placement: 'bottom',
    glossaryTerm: 'kpi',
  },
];
